<template>
  <div class="giftee-column-list">
    <GifteeColumn
      v-for="gifteeColumn in gifteeColumns"
      :key="gifteeColumn.id"
      :giftee-column-id="gifteeColumn.id"
      :image-url="gifteeColumn.imageUrl"
      :title="gifteeColumn.title"
    />
  </div>
</template>
<script>
import GifteeColumn from './GifteeColumn.vue'
export default {
  components: { GifteeColumn },
  props: {
    gifteeColumns: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.$emit('mount')
    })
  }
}
</script>
<style lang="scss" scoped>
.giftee-column-list {
  @extend %custom-scrollbar;
  display: flex;
  overflow: visible;
}
</style>
